/**
 * @description Ações relacionadas às manipulações dos Exames solicitados
 * @author Diego Sabino Amorim de Araújo
 * @file ExamesSolicitadosActions.js
 *
 * @license Copyright (c) 2021 SIGEP DIGETI ITEP/RN
 */

export const SET_PROCESSANDO_EXAME_SOLICITADO = 'SET_PROCESSANDO_EXAME_SOLICITADO'
export const SET_EXAME_SOLICITADO = 'FETCH_EXAME_SOLICITADO'
export const ASSUMIR_EXAME = 'ASSUMIR_EXAME'
export const ABANDONAR_EXAME = 'ABANDONAR_EXAME'
export const FETCH_EXAME_SOLICITADO = 'FETCH_EXAME_SOLICITADO'
export const FETCH_EXAMES_SOLICITADOS_DOS_SETORES_DO_USUARIO =
  'FETCH_EXAMES_SOLICITADOS_DOS_SETORES_DO_USUARIO'
export const FETCH_EXAMES_SOLICITADOS_PENDENTES_DOS_SETORES_DO_USUARIO =
  'FETCH_EXAMES_SOLICITADOS_PENDENTES_DOS_SETORES_DO_USUARIO'
export const FETCH_EXAMES_SOLICITADOS_EM_ANDAMENTO_DOS_SETORES_DO_USUARIO =
  'FETCH_EXAMES_SOLICITADOS_EM_ANDAMENTO_DOS_SETORES_DO_USUARUI'
export const FETCH_EXAMINADORES_CADIDATOS = 'FETCH_EXAMINADORES_CADIDATOS'
export const SET_PROCESSANDO_EXAMES_SOLICITADOS_DO_SETOR =
  'SET_PROCESSANDO_EXAMES_SOLICITADOS_DO_SETOR'
export const SET_PROCESSANDO_EXAMES_SOLICITADOS_PENDENTES_DO_SETOR =
  'SET_PROCESSANDO_EXAMES_SOLICITADOS_PENDENTES_DO_SETOR'
export const SET_PROCESSANDO_EXAMES_SOLICITADOS_EM_ANDAMENTO_DO_SETOR =
  'SET_PROCESSANDO_EXAMES_SOLICITADOS_EM_ANDAMENTO_DO_SETOR'

export const setProcessando = (value) => async (dispatch) => {
  dispatch({
    type: SET_PROCESSANDO_EXAME_SOLICITADO,
    isProcessando: value,
  })
}
